import { useGetQuoteProductCommentTargetQuery } from '@codezo/graphql';
import { MessageSquareOff } from 'lucide-react';
import { Link, Navigate } from 'react-router-dom';
import { Loading } from '../job/JobPage';

/**
 * A comment notification: ask the backend where the message lives and open
 * that job on that product's thread. Null means the supplier can no longer
 * open it — the request was withdrawn, say — which is said, not bounced.
 */
export function CommentTargetRedirect({ commentId }: { commentId: string }) {
	const { data, loading } = useGetQuoteProductCommentTargetQuery({
		variables: { id: commentId },
		fetchPolicy: 'no-cache',
	});
	const target = data?.getQuoteProductCommentTarget;

	if (loading) return <Loading />;

	if (target?.vetterJobId) {
		return (
			<Navigate
				to={`/jobs/${encodeURIComponent(target.vetterJobId)}?thread=${encodeURIComponent(target.orderQuoteItemId)}`}
				replace
			/>
		);
	}

	return (
		<div className="flex h-full flex-col items-center justify-center gap-3 px-4 text-center">
			<MessageSquareOff size={20} className="text-text-4" />
			<div className="text-base text-text-1">This message is no longer available</div>
			<p className="max-w-sm text-sm text-text-3">
				The price request it belonged to may have been withdrawn.
			</p>
			<Link to="/jobs" className="text-sm text-text-2 underline-offset-2 hover:underline">
				Go to your jobs
			</Link>
		</div>
	);
}
